import { useRouter } from '@funtech-int/rival-react';
import { useCallback } from 'react';

import { useSearchParams } from '@/shared/hooks/useSearchParams';

import { mainRoute } from '../routes';

export const useMultiOfferTab = () => {
    const router = useRouter();
    const searchParams = useSearchParams();
    const paywallOfferTab = searchParams.get('paywallOfferTab');

    const setMultiOfferTab = useCallback(
        (tabId: string) => {
            if (tabId === paywallOfferTab) {
                return;
            }

            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set('paywallOfferTab', tabId);

            router.navigate({
                to: mainRoute(),
                replace: true,
                meta: {
                    searchParams: newSearchParams,
                },
            });
        },
        [paywallOfferTab, searchParams, router]
    );

    return {
        tabId: paywallOfferTab ?? 'base',
        setMultiOfferTab,
    };
};
